<div class="modal-body content width-700">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('Header', { action: isNew ? 'erstellen' : 'ändern'})}}
    </span>
		<div class="content">
			<exg-input [(ngModel)]="dataModelClone.frmTName"
			           [caption]="getRessource('frmTName')">
			</exg-input>
			<exg-textarea [(ngModel)]="dataModelClone.frmTDescription"
			              [caption]="getRessource('frmTDescription')">
			</exg-textarea>
			<app-exg-select-enumeration [(value)]="dataModelClone.frmT_aue_enmIdent_Versicherungsart"
			                            [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')"
			                            enumerationName="Versicherungsart">
			</app-exg-select-enumeration>
			<app-exg-select-enumeration [(value)]="dataModelClone.frmT_enmIdent_DokTyp"
			                            [caption]="getRessource('frmT_enmIdent_DokTyp')"
			                            [required]="true"
			                            [enumerationList]="dokTypList">
			</app-exg-select-enumeration>
			<exg-switch [(ngModel)]="dataModelClone.frmTIsDraft"
			            caption="Entwurf">
			</exg-switch>
			<ng-container *ngIf="isNew">
				<div (filesSelect)="onFilesSelect($event)"
				     [multiple]="false"
				     [dnd]="true"
				     *ngIf="selectedFiles.length === 0"
				     class="app-drag-drop" appExgDirectUploadV2>
					{{getResource('FileDropText')}}
				</div>
				<ng-container *ngFor="let selectedFile of selectedFiles; index as i">
					<div class="list-row  list-single-line list-row-auto-1-auto typo-small"
					     *ngIf="selectedFile && selectedFile.extension">
						<div class="list-icon">
							<i class="far" flow="right"
							   [tooltip]="!isValidPDF(selectedFile.size, selectedFile.extension) ? getRessource('NoSupported') : selectedFile.extension.toUpperCase()"
							   [class.c-red]="!isValidPDF(selectedFile.size, selectedFile.extension)"
							   [class.fa-file-pdf]="selectedFile.extension.toUpperCase() === 'PDF'"
							   [class.fa-file-excel]="selectedFile.extension.toUpperCase() === 'XLSX'"
							   [class.fa-file-word]="selectedFile.extension.toUpperCase() === 'DOCX'"
							   [class.fa-file-image]="selectedFile.extension.toUpperCase() === 'JPEG' || selectedFile.extension.toUpperCase() === 'PNG'"
							   [class.fa-exclamation-triangle]="!isValidPDF(selectedFile.size, selectedFile.extension)">
							</i>
						</div>
						<span class="list-primary-text" [class.c-red]="!isValidPDF(selectedFile.size, selectedFile.extension)">
            {{
                getResource('File', {
                    Filename: selectedFile.name,
                    Filesize: appSvc.file.calcFileSize(selectedFile.size, false)
                        + (!proofFileSize(selectedFile.size) ? ' - ' + getRessource('NoSupported') : '')
                }) + ' '
							}}
          </span>
						<div class="">
							<i (click)="deleteFile(selectedFile)"
							   [class.c-red]="!isValidPDF(selectedFile.size, selectedFile.extension)"
							   [class.fa-trash]="isValidPDF(selectedFile.size, selectedFile.extension)"
							   [class.fa-times]="!isValidPDF(selectedFile.size, selectedFile.extension)"
							   class="fa-regular search-filter-action">
							</i>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="delete()" class="md-btn"
			        *ngIf="dataModelClone?.frmTID">
				{{getGlobal('Delete')}}
			</button>
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()"
			        [class.disabled]="isDisabled"
			        class="md-btn">
				{{isNew ? getGlobal('Create') : getGlobal('Save')}}
			</button>
		</div>
	</div>
</div>
